document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const drawer = document.querySelector('[data-mobile-drawer]');
  const overlay = document.querySelector('[data-drawer-overlay]');
  const searchPanel = document.querySelector('[data-search-panel]');
  const menuButtons = document.querySelectorAll('[data-menu-open]');
  let lastMenuTrigger = null;

  const setDrawer = (open) => {
    if (!drawer || !overlay) return;
    drawer.hidden = !open;
    overlay.hidden = !open;
    drawer.setAttribute('aria-hidden', String(!open));
    menuButtons.forEach((button) => button.setAttribute('aria-expanded', String(open)));
    body.classList.toggle('drawer-open', open);
    if (open) {
      drawer.querySelector('[data-menu-close]')?.focus();
    } else {
      lastMenuTrigger?.focus();
    }
  };

  menuButtons.forEach((button) => {
    button.addEventListener('click', () => {
      lastMenuTrigger = button;
      if (searchPanel) searchPanel.hidden = true;
      setDrawer(true);
    });
  });
  document.querySelectorAll('[data-menu-close], [data-drawer-overlay]').forEach((button) => {
    button.addEventListener('click', () => setDrawer(false));
  });
  drawer?.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => setDrawer(false));
  });

  document.querySelectorAll('[data-search-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!searchPanel) return;
      const nextState = searchPanel.hidden;
      searchPanel.hidden = !nextState;
      button.setAttribute('aria-expanded', String(nextState));
      if (nextState) searchPanel.querySelector('input')?.focus();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setDrawer(false);
      if (searchPanel) searchPanel.hidden = true;
    }
  });

  document.querySelectorAll('[data-product-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const selected = select.options[select.selectedIndex];
      const form = select.closest('form');
      const button = form?.querySelector('[data-add-to-cart]');
      const price = form?.closest('[data-product-root]')?.querySelector('[data-product-price]');
      if (price && selected.dataset.price) price.textContent = selected.dataset.price;
      if (button) {
        const available = selected.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
      }
    });
  });
});
/* Product image zoom */
document.addEventListener('DOMContentLoaded', () => {
  const galleryImages = Array.from(
    document.querySelectorAll('.product-gallery__item img')
  );

  if (!galleryImages.length) return;

  const zoomSteps = [1, 1.5, 2, 3];
  let currentIndex = 0;
  let zoomIndex = 0;
  let lastFocusedImage = null;
  let touchStartX = 0;

  const viewer = document.createElement('div');

  viewer.className = 'product-lightbox';
  viewer.hidden = true;
  viewer.setAttribute('role', 'dialog');
  viewer.setAttribute('aria-modal', 'true');
  viewer.setAttribute('aria-label', 'Product image viewer');

  viewer.innerHTML = `
    <div class="product-lightbox__bar">
      <span class="product-lightbox__counter"></span>

      <div class="product-lightbox__tools">
        <button type="button" data-zoom-out aria-label="Zoom out">−</button>
        <span class="product-lightbox__zoom">1×</span>
        <button type="button" data-zoom-in aria-label="Zoom in">+</button>
        <button
          class="product-lightbox__close"
          type="button"
          data-zoom-close
          aria-label="Close"
        >×</button>
      </div>
    </div>

    <button
      class="product-lightbox__arrow product-lightbox__arrow--prev"
      type="button"
      data-zoom-prev
      aria-label="Previous image"
    >‹</button>

    <div class="product-lightbox__stage">
      <img class="product-lightbox__image" alt="">
    </div>

    <button
      class="product-lightbox__arrow product-lightbox__arrow--next"
      type="button"
      data-zoom-next
      aria-label="Next image"
    >›</button>
  `;

  document.body.appendChild(viewer);

  const stage = viewer.querySelector('.product-lightbox__stage');
  const largeImage = viewer.querySelector('.product-lightbox__image');
  const counter = viewer.querySelector('.product-lightbox__counter');
  const zoomLabel = viewer.querySelector('.product-lightbox__zoom');
  const closeButton = viewer.querySelector('[data-zoom-close]');
  const previousButton = viewer.querySelector('[data-zoom-prev]');
  const nextButton = viewer.querySelector('[data-zoom-next]');
  const zoomInButton = viewer.querySelector('[data-zoom-in]');
  const zoomOutButton = viewer.querySelector('[data-zoom-out]');

  function getLargeImageURL(image) {
    const source = image.currentSrc || image.src;

    try {
      const url = new URL(source, window.location.href);
      url.searchParams.set('width', '2400');
      return url.href;
    } catch (error) {
      return source;
    }
  }

  function applyZoom() {
    const zoom = zoomSteps[zoomIndex];

    zoomLabel.textContent = `${zoom}×`;
    zoomOutButton.disabled = zoomIndex === 0;
    zoomInButton.disabled = zoomIndex === zoomSteps.length - 1;
    stage.classList.toggle('is-zoomed', zoom > 1);

    if (zoom === 1) {
      largeImage.style.width = '';
      largeImage.style.maxWidth = '';
      largeImage.style.maxHeight = '';
      stage.scrollTo({ top: 0, left: 0 });
    } else {
      largeImage.style.width = `${zoom * 100}%`;
      largeImage.style.maxWidth = 'none';
      largeImage.style.maxHeight = 'none';

      requestAnimationFrame(() => {
        stage.scrollTo({
          left: Math.max(0, (stage.scrollWidth - stage.clientWidth) / 2),
          top: Math.max(0, (stage.scrollHeight - stage.clientHeight) / 2),
          behavior: 'smooth'
        });
      });
    }
  }

  function showImage(index) {
    currentIndex =
      (index + galleryImages.length) % galleryImages.length;

    zoomIndex = 0;

    const originalImage = galleryImages[currentIndex];

    largeImage.src = getLargeImageURL(originalImage);
    largeImage.alt = originalImage.alt || 'Product image';

    counter.textContent =
      `${currentIndex + 1} / ${galleryImages.length}`;

    previousButton.hidden = galleryImages.length < 2;
    nextButton.hidden = galleryImages.length < 2;

    applyZoom();
  }

  function openViewer(index, image) {
    lastFocusedImage = image;
    showImage(index);

    viewer.hidden = false;
    document.body.classList.add('lightbox-open');
    closeButton.focus();
  }

  function closeViewer() {
    viewer.hidden = true;
    document.body.classList.remove('lightbox-open');
    largeImage.removeAttribute('src');
    lastFocusedImage?.focus();
  }

  galleryImages.forEach((image, index) => {
    image.classList.add('product-gallery__zoom-image');
    image.tabIndex = 0;
    image.setAttribute('role', 'button');
    image.setAttribute('aria-label', `Open product image ${index + 1}`);

    const item = image.closest('.product-gallery__item');

    if (item && !item.querySelector('.product-gallery__zoom-badge')) {
      item.classList.add('has-image-zoom');

      const badge = document.createElement('span');
      badge.className = 'product-gallery__zoom-badge';
      badge.setAttribute('aria-hidden', 'true');
      badge.textContent = 'Zoom +';

      item.appendChild(badge);
    }

    image.addEventListener('click', () => {
      openViewer(index, image);
    });

    image.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openViewer(index, image);
      }
    });
  });

  closeButton.addEventListener('click', closeViewer);

  previousButton.addEventListener('click', () => {
    showImage(currentIndex - 1);
  });

  nextButton.addEventListener('click', () => {
    showImage(currentIndex + 1);
  });

  zoomInButton.addEventListener('click', () => {
    zoomIndex = Math.min(zoomSteps.length - 1, zoomIndex + 1);
    applyZoom();
  });

  zoomOutButton.addEventListener('click', () => {
    zoomIndex = Math.max(0, zoomIndex - 1);
    applyZoom();
  });

  largeImage.addEventListener('click', () => {
    zoomIndex = zoomIndex === 0 ? 2 : 0;
    applyZoom();
  });

  stage.addEventListener(
    'touchstart',
    event => {
      if (event.touches.length === 1) {
        touchStartX = event.touches[0].clientX;
      }
    },
    { passive: true }
  );

  stage.addEventListener(
    'touchend',
    event => {
      if (zoomIndex !== 0 || !event.changedTouches.length) return;

      const movement =
        event.changedTouches[0].clientX - touchStartX;

      if (Math.abs(movement) > 60) {
        showImage(currentIndex + (movement < 0 ? 1 : -1));
      }
    },
    { passive: true }
  );

  document.addEventListener('keydown', event => {
    if (viewer.hidden) return;

    if (event.key === 'Escape') closeViewer();
    if (event.key === 'ArrowLeft') showImage(currentIndex - 1);
    if (event.key === 'ArrowRight') showImage(currentIndex + 1);
  });
});